import { useEffect, useState } from "react";
import PageLayout from "../components/PageLayout";
import { useNavigate } from "react-router-dom";

// icons
import IconComponent from "../components/Icon";
import { FaArrowDown, FaArrowUp, FaPlus, FaSearch } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";

// services
import axiosInstance from "../api/apiClient";
import Book from "../components/Book";
import { book } from "../assets/data/constants";


const Library = () => {
  const navigate = useNavigate();

  const [library, setLibrary] = useState([]);
  const [sortedLibrary, setSortedLibrary] = useState([]);
  const [order, setOrder] = useState('asc');
  const [sort, setSort] = useState('date-added');
  const [searchString, setSearchString] = useState('');

  const sortLibraryArray = () => {
      switch (sort) {
        case 'date-added':
          setSortedLibrary([...library].sort((a: any, b: any) => new Date(b['Date Added']).valueOf() - new Date(a['Date Added']).valueOf()));
          break;
        case 'date-read':
          setSortedLibrary([...library].sort((a: any, b: any) => new Date(b['Date Read']).valueOf() - new Date(a['Date Read']).valueOf()));
          break;
        case 'title':
          setSortedLibrary([...library].sort((a: any, b: any) => a['Title'].toString().trim().localeCompare(b['Title'].toString().trim())));
          break;
        case 'author':
          setSortedLibrary([...library].sort((a: any, b: any) => a['Author'].localeCompare(b['Author'])));
          break;
        case 'rating':
          setSortedLibrary([...library].sort((a: any, b: any) => b['Average Rating'] - a['Average Rating']));
          break;
        default:
          break;
      }
    }

    const getLibraryData = async () => {

      await axiosInstance.get('/getUserBooks').then((data:any) => {
        setLibrary(data.map((book: any) => {return {...book, "In User Library": true}}).sort((a: any, b: any) => new Date(b['Date Added']).valueOf() - new Date(a['Date Added']).valueOf()));
        setSortedLibrary(data.map((book: any) => {return {...book, "In User Library": true}}).sort((a: any, b: any) => new Date(b['Date Added']).valueOf() - new Date(a['Date Added']).valueOf()));
      }).catch((error: any) => {
        console.error(error);
      });
    };

    

    useEffect(() => {
      getLibraryData();
    }, []);

    useEffect(() => {
      // reverse library array
      const reversedArray = [...sortedLibrary].reverse();
      setSortedLibrary(reversedArray);
    }, [order]);

    useEffect(() => {
      sortLibraryArray();
    }, [sort]);

    if (!library) {
      return <div>Loading...</div>;
    }

    return (
    <PageLayout
        headerText={`My library (${library.length})`}
        type="light"
      >
        <div className="bg-white rounded-3xl shadow-lg p-4 min-h-20 mt-[40px]">
          <div className="flex items-center justify-between">
          <form className="flex items-center" onSubmit={(e) => e.preventDefault() }>
            <div className="relative">
              <input type="text" placeholder="Search" className="p-2 rounded-lg border border-gray-300 focus:outline-none focus:border-[#8784D8]" value={searchString} onChange={(e) => setSearchString(e.target.value)}/>
              {searchString.length > 0 && 
                <button style={{position: 'absolute', right: 0}} className="ml-2 p-2 h-full rounded-lg" onClick={() => setSearchString('')}>
                  <IconComponent icon={IoMdClose} width={20} color="#60637A" className="drop-shadow-sm"/>
                </button>
            }
            </div>
            
           
            <button type="submit" className="ml-2 p-2 h-full rounded-lg bg-[#8784D8] text-white hover:bg-[#6c6aad] focus:outline-none">
              <IconComponent icon={FaSearch} width={20} color="#ffffff" className="drop-shadow-sm"/>
            </button>
          </form>
          <div className="flex items-center">
            <p className="mr-2">Sort by</p>
            <select onChange={(e) => setSort(e.target.value)} value={sort} className="p-2 rounded-lg border border-gray-300 focus:outline-none focus:border-[#8784D8]">
              <option value="date-added">Date Added</option>
              <option value="date-read">Date Read</option>
              <option value="title">Title</option>
              <option value="author">Author</option>
              <option value="average-rating">Average Rating</option>
              <option value="my-rating">My Rating</option>
              <option value="publication-year">Publication Year</option>
              <option value="number-of-pages">Number of Pages</option>
              <option value="read-count">Read Count</option>
              <option value="owned">Owned</option>
            </select>
            {order === "asc" 
              ? <IconComponent icon={FaArrowDown} width={20} color="#60637A" className="ml-2 cursor-pointer" onClick={() => setOrder("desc")}/> 
              : <IconComponent icon={FaArrowUp} width={20} color="#60637A" className="ml-2 cursor-pointer" onClick={() => setOrder("asc")}/>
            }
            
          </div>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-6 gap-4 mt-[40px]">

            {searchString.length === 0 &&

              <div className="relative w-32 h-48" onClick={() => navigate('/browse')}>

                <div className="w-32 h-48 bg-[var(--dark-grey)] rounded-lg flex items-center justify-center">
                  <p className="text-white text-center">
                    <IconComponent icon={FaPlus} width={30} color="#ffffff" className="drop-shadow-xl"/>
                  </p>
                </div>

                <div className="absolute top-0 left-0 right-0 bottom-0 h-full bg-black bg-opacity-50 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300 rounded-lg cursor-pointer">
                  <p className="text-white text-center">
                    <IconComponent icon={FaPlus} width={30} color="#ffffff" className="drop-shadow-xl" />
                  </p>
                </div>

              </div>
            
            }
                 
           
            {sortedLibrary.filter((book: any) => book['Title'].toLowerCase().includes(searchString.toLowerCase()) || book['Author'].toLowerCase().includes(searchString.toLowerCase()))
            .map((book: book, key: any) => {
              return (
                <Book key={key} book={book} />
              )})}
          </div>
        </div>
      </PageLayout>
    );
}

export default Library;